module.exports = __webpack_public_path__ + "static/dermot-24604ca900745a50f1c7c94050ff4ee9.png";